import { AlertElProps } from 'components/Landing/utils/getAlertFromKey';
import { ErrorType } from 'components/Landing/content';
import { MessageEl } from './MessageEl';
import { NavigateButton } from './NavigateButton';

export const veeqoErrors = (jobId?: string): Record<ErrorType, AlertElProps> => ({
  DEFAULT: {
    titleId: 'veeqo-default-error-title',
    message: (
      <MessageEl
        preTextId="veeqo-default-error-pretext"
        href="helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  INVALID_INPUT: {
    titleId: 'veeqo-default-error-title',
    message: (
      <MessageEl
        preTextId="veeqo-default-error-pretext"
        href="helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  INTERNAL_ERROR: {
    titleId: 'veeqo-default-error-title',
    message: (
      <MessageEl
        preTextId="veeqo-default-error-pretext"
        href="helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  EMAIL_ALREADY_IN_USE: {
    titleId: 'veeqo-error-email-in-use-title',
    message: <MessageEl preTextId="veeqo-error-email-in-use-pretext" jobId={jobId} />,
    rightActions: [
      <NavigateButton href="https://app.veeqo.com/signin" textId="sign-in-to-veeqo" />,
    ],
  },
  INSUFFICIENT_PERMISSIONS: {
    titleId: 'veeqo-default-error-title',
    message: <MessageEl preTextId="veeqo-error-insufficient-permissions-pretext" jobId={jobId} />,
    rightActions: [],
  },
  MULTIPLE_STORE_COLLECTION: {
    titleId: 'veeqo-default-error-title',
    message: (
      <MessageEl
        preTextId="veeqo-default-error-pretext"
        href="helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  STORE_CONNECTION_ERROR: {
    titleId: 'veeqo-error-store-connection-title',
    message: <MessageEl preTextId="veeqo-error-store-connection-pretext" jobId={jobId} />,
    rightActions: [
      <NavigateButton href="https://app.veeqo.com/signin" textId="sign-in-to-veeqo" />,
    ],
  },
  STORE_ALREADY_IN_USE: {
    titleId: 'veeqo-error-store-in-use-title',
    message: (
      <MessageEl
        preTextId="veeqo-error-store-in-use-pretext"
        href="helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  MISSING_MERCHANT_ADDRESS: {
    titleId: 'veeqo-error-missing-merchant-address-title',
    message: <MessageEl preTextId="veeqo-error-missing-merchant-address-pretext" jobId={jobId} />,
    rightActions: [],
  },
  MISSING_MERCHANT_NAME: {
    titleId: 'veeqo-error-missing-merchant-name-title',
    message: <MessageEl preTextId="veeqo-error-missing-merchant-name-pretext" jobId={jobId} />,
    rightActions: [],
  },
  OWNER_STILL_ONBOARDING: {
    titleId: 'veeqo-error-owner-still-onboarding-title',
    message: (
      <MessageEl
        preTextId="veeqo-error-owner-still-onboarding-pretext"
        href="helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  ACCOUNT_ALREADY_LINKED: {
    titleId: 'veeqo-error-account-already-linked-title',
    message: <MessageEl preTextId="veeqo-error-account-already-linked-pretext" jobId={jobId} />,
    rightActions: [],
  },
});
